import { node, string } from 'prop-types'
import { AnalyticsLayer } from '@opallabs/quanta'
import { kuiperClassNames } from '../utils'

import './styles.scss'

const Toolbar = ({
  centerChildren,
  children,
  classes,
  leftChildren,
  rightChildren,
}) => (
  <AnalyticsLayer name="Toolbar">
    <section className={kuiperClassNames('toolbar', classes)}>
      <div className={kuiperClassNames('toolbar-slot toolbar-left')}>
        {leftChildren}
      </div>
      <div className={kuiperClassNames('toolbar-slot toolbar-center')}>
        {centerChildren || children}
      </div>
      <div className={kuiperClassNames('toolbar-slot toolbar-right')}>
        {rightChildren}
      </div>
    </section>
  </AnalyticsLayer>
)

Toolbar.propTypes = {
  centerChildren: node,
  children: node,
  classes: string,
  leftChildren: node,
  rightChildren: node,
}

export default Toolbar
